import {Utils} from "./Utils";


function initSideMenu() {

    // Helper function to add event listeners to navigation links
    const addNavClickListener = (
        navLinks: NodeListOf<HTMLElement>,
        level: number,
    ) => {
        navLinks.forEach((link) => {
            link.addEventListener("click", function () {
                const subnavigations = document.querySelectorAll(
                    ".c-sidemenu__subnavigation",
                )
                subnavigations.forEach((subnav) => {
                    subnav.classList.remove(
                        "c-sidemenu__subnavigation--is-open",
                    )
                })

                const sidemenu = document.querySelector(
                    ".c-sidemenu",
                ) as HTMLElement
                sidemenu.classList.remove(
                    "c-sidemenu--level-1-open",
                    "c-sidemenu--level-2-open",
                    "c-sidemenu--level-3-open",
                )
                sidemenu.classList.add(`c-sidemenu--level-${level}-open`)

                const nextSubnav = (this as HTMLElement)
                    .nextElementSibling as HTMLElement
                if (nextSubnav) {
                    nextSubnav.classList.add(
                        "c-sidemenu__subnavigation--is-open",
                    )
                }

                const navigationLinks = document.querySelectorAll(
                    ".c-sidemenu__navigation-link",
                )
                navigationLinks.forEach((navLink) => {
                    navLink.classList.remove(
                        "c-sidemenu__navigation-link--is-open",
                    )
                })
                ;(this as HTMLElement).classList.add(
                    "c-sidemenu__navigation-link--is-open",
                )
            })
        })
    }

    // Open first sublevel
    const firstLevelLinks = document.querySelectorAll<HTMLElement>(
        ".c-sidemenu__navigation-list > .c-sidemenu__navigation-item--has-subnavigation > .c-sidemenu__navigation-link",
    )
    addNavClickListener(firstLevelLinks, 1)

    // Open second sublevel
    const secondLevelLinks = document.querySelectorAll<HTMLElement>(
        ".c-sidemenu__navigation-list > .c-sidemenu__navigation-item--has-subnavigation > .c-sidemenu__subnavigation > .c-sidemenu__subnavigation-list > .c-sidemenu__navigation-item--has-subnavigation > .c-sidemenu__navigation-link",
    )
    addNavClickListener(secondLevelLinks, 2)

    // Open third sublevel
    const thirdLevelLinks = document.querySelectorAll<HTMLElement>(
        ".c-sidemenu__navigation-list > .c-sidemenu__navigation-item--has-subnavigation > .c-sidemenu__subnavigation > .c-sidemenu__subnavigation-list > .c-sidemenu__navigation-item--has-subnavigation .c-sidemenu__navigation-item--has-subnavigation > .c-sidemenu__navigation-link",
    )
    addNavClickListener(thirdLevelLinks, 3)

    // Close sublevels
    const closeBtn = document.querySelector<HTMLElement>(".c-sidemenu__close")
    if (closeBtn) {
        if (closeBtn) {
            closeBtn.addEventListener("click", () => {
                const subnavigations = document.querySelectorAll(
                    ".c-sidemenu__subnavigation",
                )
                subnavigations.forEach((subnav) => {
                    subnav.classList.remove("c-sidemenu__subnavigation--is-open")
                })

                const sidemenu = document.querySelector<HTMLElement>(".c-sidemenu")
                if (sidemenu) {
                    sidemenu.classList.remove(
                        "c-sidemenu--level-1-open",
                        "c-sidemenu--level-2-open",
                        "c-sidemenu--level-3-open",
                    )
                }

                const navigationLinks = document.querySelectorAll(
                    ".c-sidemenu__navigation-link",
                )
                navigationLinks.forEach((navLink) => {
                    navLink.classList.remove("c-sidemenu__navigation-link--is-open")
                })
            })
        }

        // Click outside event
        document.addEventListener("click", (event) => {
            const target = event.target as HTMLElement
            const submenu = document.querySelector(".c-sidemenu__subnavigation")

            // Check if click is outside of menu and if menu is open
            if (
                !target.closest(".c-sidemenu") &&
                submenu &&
                submenu.classList.contains("c-sidemenu__subnavigation--is-open")
            ) {
                const subnavigations = document.querySelectorAll(
                    ".c-sidemenu__subnavigation",
                )
                subnavigations.forEach((subnav) => {
                    subnav.classList.remove("c-sidemenu__subnavigation--is-open")
                })

                const sidemenu = document.querySelector(
                    ".c-sidemenu",
                ) as HTMLElement
                sidemenu.classList.remove(
                    "c-sidemenu--level-1-open",
                    "c-sidemenu--level-2-open",
                    "c-sidemenu--level-3-open",
                )

                const navigationLinks = document.querySelectorAll(
                    ".c-sidemenu__navigation-link",
                )
                navigationLinks.forEach((navLink) => {
                    navLink.classList.remove("c-sidemenu__navigation-link--is-open")
                })
            }
        })
    }
}

Utils.executeWhenDocumentIsReady(initSideMenu);
